import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, safeFetch, SharedContentDocument } from "../SharedContentFetchStrategy";
import { AttachmentResponseModule } from "@/store/modules/attachment-response.store";

export class AttachmentRequestFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.ATTACHMENT_REQUEST;
  }

  fetch(partnerId: string, attachmentId: string, accessToken: string): Promise<SharedContentDocument> {
    return safeFetch(attachmentId, ResourceEnum.ATTACHMENT_REQUEST, async () => {
      const result = await AttachmentResponseModule.get({ partnerId, attachmentId, accessToken });

      return result;
    });
  }
}
